<template>
  <div
    class="z-50 flex items-center bg-white border border-[#00423D] shadow-lg rounded-[12px] transition-all
      w-full h-auto 
      p-3 sm:p-0"
  >
    <!-- Left Image Illustration -->
    <div class="hidden sm:block ml-[21px] mt-[16px] w-[70px] h-[110px] flex-shrink-0">
      <img src="/images/toster_icon.svg" alt="Toaster Icon" class="w-full h-full object-contain" />
    </div>
    
    <!-- Main Content -->
    <div class="flex flex-col justify-center ml-0 sm:ml-5 flex-1 gap-1">
      <div
        class="font-minion font-semibold text-[22px] sm:text-[34px] leading-tight sm:leading-[1.09] h-auto sm:h-[32px] mt-0 sm:mt-[18px] text-[#00423D]"
      >
        {{ title }}
      </div>
      <div
        class="font-sans text-[15px] sm:text-[18px] leading-snug sm:leading-[1.18] mb-3 sm:mt-[10px] text-[#00423D] font-normal"
      >
        You just unlocked the
        <a
          v-if="resourceName && resourceLink"
          :href="resourceLink"
          class="font-sans font-semibold underline text-[#00423D]"
          target="_blank"
          @click.prevent="$emit('resource-link-click', resourceName)"
        >{{ resourceName }}</a>
        <span v-else class="font-sans font-semibold underline text-[#00423D]">{{ resourceName }}</span>
        resource.
        <div v-if="additionalText" class="mt-1 font-sans text-[15px] sm:text-[18px] leading-snug sm:leading-[1.18] text-[#00423D] font-normal">
          {{ additionalText }}
        </div>
      </div>
    </div>
    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="absolute right-2 top-2 sm:right-[17px] sm:top-[15px] w-8 h-8 sm:w-[29px] sm:h-[29px] bg-[#00423D] rounded-full flex items-center justify-center border-none cursor-pointer"
      aria-label="Close"
      type="button"
    >
      <span class="font-sans text-white font-semibold text-lg sm:text-[18px] leading-[1.5]">×</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "CustomToaster",
  props: {
    title: {
      type: String,
      default: "Well done!",
    },
    resourceName: {
      type: String,
      default: "Gift Pyramid",
    },
    resourceLink: {
      type: String,
      default: "",
    },
    additionalText: {
      type: String,
      default: "",
    },
  },
};
</script>